import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSendEmailConfirmationMutation } from '../../../features/user/userApiSlice';
import { ReactComponent as MySpinner } from '../../.././animations/mySpinner.svg';

const EmailVerification = ({ email: savedEmail }) => {
    const { t } = useTranslation();
    const [sendEmailConfirmation] = useSendEmailConfirmationMutation();
    const [isOpen, setIsOpen] = useState(false);
    const [text, setText] = useState('');
    const [type, setType] = useState('notice');
    const [isClicked, setIsClicked] = useState(false);
    const [email, setEmail] = useState(savedEmail || '');
    const [cooldown, setCooldown] = useState(0);

    useEffect(() => {
        if (cooldown <= 0) return undefined;
        const timer = window.setInterval(() => {
            setCooldown(value => Math.max(0, value - 1));
        }, 1000);
        return () => window.clearInterval(timer);
    }, [cooldown]);

    const onClick = async () => {
        try {
            setIsClicked(true);
            const normalizedEmail = email.trim().toLowerCase();
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!normalizedEmail || !regex.test(normalizedEmail)) {
                throw new Error('TheEmailIsNotValid');
            }

            const res = await sendEmailConfirmation({ email: normalizedEmail, language: window.localStorage.getItem('i18nextLng') || 'en' }).unwrap();
            if (!res.success) throw new Error(res.message);

            setEmail(normalizedEmail);
            setText(t('ConfirmationLetterSentTo', { email: normalizedEmail }));
            setType('notice');
            setIsOpen(true);
            setCooldown(res.retryAfter || 60);
        } catch (error) {
            const errorKey = error?.data?.message || error?.message || 'EmailDeliveryUnavailable';
            setText(t(errorKey));
            setType('error');
            setIsOpen(true);
            if (error?.status === 429 || error?.originalStatus === 429) {
                setCooldown(error?.data?.retryAfter || 60);
            }
            console.error(error);
        } finally {
            setIsClicked(false);
        }
    };

    return <div className="col-xl-12">
        <div className="dashboard-box" style={{ boxShadow: '0 2px 8px rgba(255,0,0,0.2)' }}>
            <div className="headline" style={{ borderBottomColor: 'rgba(255,0,0,0.2)' }}>
                <h3><i style={{ color: 'red' }} className="icon-feather-user-check"></i> {t("Verification")}</h3>
            </div>

            <div className="content with-padding">
                <div className='row'>
                    <div className='col-xl-8 margin-bottom-15'>
                        <input type="email" className="with-border" placeholder='name@example.com'
                        value={email} onChange={e => {
                            setEmail(e.target.value);
                            if (isOpen) setIsOpen(false);
                        }} />
                    </div>
                    
                    <div className='col-xl-4'>
                        
                        {isClicked
                            ? <div style={{ height: '48px', width: 'inherit' }}>
                                <span style={{ height: '48px', width: 'inherit', textAlign: 'center' }} className='button ripple-effect'>
                                    <MySpinner style={{
                                        display: 'inline-block',
                                        marginBottom: '-10px',
                                    }} />
                                    {t("Verify")}
                                </span>
                            </div>
                            :<button onClick={onClick} disabled={cooldown > 0} style={{ height: '48px', width: 'inherit' }} className="button ripple-effect" type="button">
                                {cooldown > 0 ? `${t("Verify")} (${cooldown}s)` : t("Verify")}
                            </button>
                        }
                    </div>
                    
                </div>

                {isOpen &&
                    <div className={`notification ${type === 'error' ? 'error' : 'notice'}`} role="alert" aria-live="polite" style={{ marginBottom: 0 }}>
                        <p>{text}</p>
                    </div>}
            </div>
        </div>
    </div>
}

export default EmailVerification;
